export enum TOAST_TYPES {
  success = 'success',
  successPermanent = 'successPermanent',
  error = 'error',
  warning = 'warning',
  info = 'info',
}
